import { createAction } from '@reduxjs/toolkit';

import { GET_DOCUMENTS_BY_CLAIM_ID } from './actionTypes';

export const getDocumentsByClaimId = createAction<{ claimId: string }>(
  GET_DOCUMENTS_BY_CLAIM_ID.BASE,
);
